import React from 'react';
import PropTypes from 'prop-types';

const Text = props => {
  const {
    jumpLinkId,
    forceSpan,
    tags,
    pos,
    value,
    isWapView,
    nic,
    prime,
    stpPrpgtnAndPrvDflt,
  } = props;
  const getTextHtml = () => {
    const id = jumpLinkId || false;
    let text = '';
    if (isWapView || forceSpan) {
      text = (
        <span
          className={`${tags} ${nic ? '' : 'id-r-component'}`}
          data-pos={pos}
          id={id}
          {...(stpPrpgtnAndPrvDflt
            ? {
                'data-ua-type': '1',
                'data-sp-pd-click': 'stpPgtnAndPrvntDefault(event)',
                onClick: event => {
                  window.stpPgtnAndPrvntDefault(event);
                },
              }
            : {})}
        >
          {value}
        </span>
      );
    } else if (tags) {
      text = (
        <span
          className={tags}
          id={id}
          {...(stpPrpgtnAndPrvDflt
            ? {
                'data-ua-type': '1',
                'data-sp-pd-click': 'stpPgtnAndPrvntDefault(event)',
                onClick: event => {
                  window.stpPgtnAndPrvntDefault(event);
                },
              }
            : {})}
        >
          {value}
        </span>
      );
    } else {
      text = value;
    }

    return text;
  };
  return (
    <>
      {prime && value}

      {!prime && getTextHtml()}
    </>
  );
};

Text.propTypes = {
  value: PropTypes.string,
  pos: PropTypes.string,
  prime: PropTypes.bool,
  isWapView: PropTypes.bool,
  tags: PropTypes.string,
  forceSpan: PropTypes.bool.isRequired,
  nic: PropTypes.bool,
  jumpLinkId: PropTypes.string,
  stpPrpgtnAndPrvDflt: PropTypes.bool,
};

Text.defaultProps = {
  value: '',
  pos: '0',
  prime: false,
  isWapView: false,
  tags: '',
  nic: false,
  jumpLinkId: '',
  stpPrpgtnAndPrvDflt: false,
};

export default Text;
